const VERSION = '2.6.8';
export function getVersionString() {
    return VERSION;
}
